import { createReducer, on } from '@ngrx/store';
import { login, loginFailed, loginSuccessful} from './auth.actions';
import * as authActions from './auth.actions'

export interface AuthState {
    // authUser : AuthUser | null
    isLoggedIn: boolean;
    loginLoading: boolean;

}

export const initialState: AuthState = {
    // authUser : null,
    isLoggedIn: false,
    loginLoading: false,
    
}

export const authReducer = createReducer(
    initialState,

    on(login, (state) => ({
        ...state, loginLoading: true
    })),

    on(loginSuccessful, (state) => ({
        ...state, loginLoading: false, isLoggedIn: true
    })),

    on(loginFailed, (state) => ({
        ...state, loginLoading: false
    })),

);